module.exports = __webpack_public_path__ + "img/MA.4a78c98e.png";